import { TreeNode } from '../types/interfaces';

export function hasChildByName(obj: TreeNode | null, nodeType: string) {
  if (obj && !obj.hasOwnProperty('children')) return false;

  if (obj) {
    for (const child of obj.children!) {
      if (child.data === nodeType) return true;
    }
    return false;
  }
}
